import React, { Fragment, useState, useEffect } from "react";
import TabsMobile from "../__template/TabsMobileComponent";
import ChevronUpIcon from "../../assets/images/icon_profile/chevron.svg";
import { useTranslation } from "react-i18next";
import CustomApp from "../../core/models/customApp";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import { isDarkColor } from "../../config/DarkColorChecker";
import headphone from "../../assets/images/headphones.svg";
import { Dialog, Disclosure, Transition } from "@headlessui/react";
import { openWhatsappAndroid } from "./../../config/AndroidBridge";
import { logoutIOS, openUrlInSafari } from "../../config/iosBridge";
import { getFaq } from "../../core/service/api";
import { use } from "i18next";

const ComponentSupport = () => {
  const { t } = useTranslation();
  const [supportOpened, setSupportOpened] = useState(false);
  const [supportMessage, setSupportMessage] = useState("");
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const [faqData, setFaqData] = useState<any>([]);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  let faq = [
    {
      title: t("FAQ.one.title"),
      description: t("FAQ.one.description"),
    },
    {
      title: t("FAQ.two.title"),
      description: t("FAQ.two.description"),
    },
    {
      title: t("FAQ.three.title"),
      description: t("FAQ.three.description"),
    },
    {
      title: t("FAQ.four.title"),
      description: t("FAQ.four.description"),
    },
    {
      title: t("FAQ.five.title"),
      description: t("FAQ.five.description"),
    },
  ];

  function openSupport() {
    setSupportOpened(true);
    setOpenDetailHistory(false);
  }

  function closeSupport() {
    setSupportOpened(false);
  }

  function sendMessage() {
    // console.log(supportMessage);
    let userStorage = JSON.parse(String(localStorage.getItem("user_redux")));
    let companyStorage = JSON.parse(String(localStorage.getItem("company")));
    let url = "";
    let anak = [];
    let phone = "6281326269992";
    let name = String(userStorage.name).split(" ").join("%20");
    if (userStorage.accounts[0].callerIdentities.length > 1) {
      for (
        let x = 0;
        x < userStorage.accounts[0].callerIdentities.length;
        x++
      ) {
        anak[x] = String(userStorage.accounts[0].callerIdentities[x].name)
          .split(" ")
          .join("%20");
        // console.log(userStorage.accounts[0].callerIdentities[x].name);
      }
      let d =
        "%20dan%20" + anak[userStorage.accounts[0].callerIdentities.length - 1];
      // d = String(d).substr(0, d.length - 3)
      anak[userStorage.accounts[0].callerIdentities.length - 1] = d;
      url = "text=Halo,%20saya%20" + name + "%20orang%20tua%20dari%20";
      url += anak;
    } else if (userStorage.accounts[0].callerIdentities.length == 1) {
      anak[0] = String(userStorage.accounts[0].callerIdentities[0].name)
        .split(" ")
        .join("%20");
      url = "text=Halo,%20saya%20" + name + "%20orang%20tua%20dari%20";
      url += anak;
    } else {
      url = "text=Halo,%20saya%20" + name;
    }
    let company = String(companyStorage.name).split(" ").join("%20");
    let pesan = String(supportMessage).split(" ").join("%20");
    url +=
      "%20dari%20" +
      company +
      "%20menemui%20kendala%20sebagai%20berikut:%0A%0A";
    url += pesan;
    let deviceType = localStorage.getItem("device");
    if (deviceType?.includes("android")) {
      // let x = `whatsapp://send?phone='${phone}'&`;
      let x = "https://wa.me/" + phone + "?";
      url = `${x}${url}`;
      let appVersion = localStorage.getItem("app_version")
        ? localStorage.getItem("app_version")
        : "PSP%20Mobile%20browser";
      appVersion = appVersion
        ? appVersion.replace("--", " ").replace(" ", "%20")
        : "PSP%20Mobile%20browser";
      url = `${url}"%0A%0ADikirim dari:%0A"${appVersion}`;
      openWhatsappAndroid(url);
      // let appVersion = localStorage.getItem("appVersion")
      //   ? localStorage.getItem("appVersion")
      //   : "PSP%20Mobile%20browser";
      // appVersion = appVersion
      //   ? appVersion.replace("--", " ").replace(" ", "%20")
      //   : "PSP%20Mobile%20browser";
      // url = `${url}"%0A%0ADikirim dari:%0A"${appVersion}`;
      // var element = document.createElement("a");
      // element.setAttribute("href", url);
      // element.click();
    } else if (deviceType?.includes("ios")) {
      let x = "https://wa.me/" + phone + "?";
      url = `${x}${url}`;
      let appVersion = localStorage.getItem("device")
        ? localStorage.getItem("device")
        : "PSP%20Mobile%20browser";
      appVersion = appVersion
        ? appVersion.replace("--", " ").replace(" ", "%20")
        : "PSP%20Mobile%20browser";
      url = `${url}"%0A%0ADikirim dari:%0A"${appVersion}`;
      openUrlInSafari(url);
    } else {
      let x = "https://wa.me/" + phone + "?";
      url = `${x}${url}`;
      window.open(url, "_blank");
    }

    // console.log(url);
    setSupportOpened(false);
  }

  const getDataFaq = () => {
    getFaq("PSPMOBILE", "id", "HOME").then(
      (res) => {
        setFaqData(res.data);
        // console.log(res);
      },
      (err) => {}
    );
  };

  useEffect(() => {
    getDataFaq();
  }, []);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 transparent`}>
        <TabsMobile name={`${t("FAQ.title")}`} backUrl={"profile"}></TabsMobile>
      </div>

      <Transition appear show={supportOpened} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeSupport}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div>{t("CUSTOMER.title")}</div>
                  </Dialog.Title>
                  <div className="mt-2">
                    <textarea
                      onChange={(e) => setSupportMessage(e.target.value)}
                      placeholder={`${t("CUSTOMER.message")}`}
                      className="w-full py-1 px-2 rounded-lg"
                    ></textarea>
                  </div>
                  <div className="mt-4 flex flex-row justify-evenly">
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`w-full h-10 mr-1 rounded-md ${
                        isDarkColor(
                          customApp?.app_secondary_accent_color
                            ? customApp.app_secondary_accent_color
                            : "text-psp-primary"
                        )
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={closeSupport}
                    >
                      {t("CUSTOMER.no")}
                    </button>
                    <button
                      type="button"
                      style={{ backgroundColor: customApp?.app_accent_color }}
                      className={`w-full h-10 ml-1 rounded-md ${
                        isDarkColor(
                          customApp?.app_accent_color
                            ? customApp.app_accent_color
                            : "text-psp-primary"
                        )
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={sendMessage}
                    >
                      {t("CUSTOMER.yes")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <section className="flex py-6 top-to-bottom mb-20 max-h-[calc(100vh-80px)] overflow-y-auto pb-36">
        <div className="flex flex-col gap-2.5 mx-4 w-full overflow-scroll">
          {faqData.map((res: any) => (
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button
                    className={`${
                      open
                        ? "bg-white flex w-full justify-between items-center bg-purple-100 px-4 py-2 text-left text-sm font-semibold rounded-lg border border-psp-primary"
                        : "bg-white flex w-full justify-between items-center bg-purple-100 px-4 py-2 text-left text-sm font-semibold rounded-lg border border-psp-primary"
                    }`}
                  >
                    <span className="w-4/5">{res.question}</span>
                    <img
                      src={ChevronUpIcon}
                      className={`${
                        open ? "rotate-0 transform" : ""
                      } h-3 w-3 text-purple-500 rotate-180 transform`}
                    />
                  </Disclosure.Button>
                  <Transition
                    show={open}
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                  >
                    <Disclosure.Panel
                      style={{ backgroundColor: "#0054e61a" }}
                      className="px-4 pb-2 py-2 -mt-2.5 text-xs font-normal text-black rounded-b-xl mx-2"
                    >
                      <span className="text-black font-montserrat">
                        {res.answer}
                      </span>
                      <img hidden={!res.image} src={res.image} />
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </section>
      <div className="fixed z-50 bottom-0 w-full bg-white px-4 py-2">
        <p className="text-sm font-poppins">{t("SUPPORT.hint")}</p>
        <button
          onClick={() => {
            openSupport();
          }}
          style={{
            backgroundColor: customApp?.app_accent_color,
          }}
          className={`disabled:bg-psp-gray w-5/12  shadow-lg shadow-psp-primary py-2.5 text-sm font-semibold rounded-lg ${
            isDarkColor(customApp.app_accent_color)
              ? "text-white"
              : "text-black"
          }`}
        >
          <div className="flex gap-2 items-center justify-center">
            <img
              src={headphone}
              width={25}
              className={`anima-icon ${
                isDarkColor(customApp?.app_accent_color) ? "" : "invert"
              }`}
            />
            {t("SUPPORT.callUs")}
          </div>
        </button>
      </div>
    </div>
  );
};

export default ComponentSupport;
